import type { ReactNode } from 'react';
import { AppToast } from 'src/utils/mantineToastAdapter';

type ToastIntent = 'primary' | 'success' | 'warning' | 'danger' | 'none';

interface ToastOptions {
  intent?: ToastIntent;
  icon?: string | ReactNode;
  timeout?: number;
  action?: { onClick: () => void; text: string };
}

// Single notification entry point. All toasts render top-center.
export const showToast = (
  message: ReactNode,
  opts: ToastOptions = {},
): string => AppToast.show({ message, intent: 'none', ...opts });

export const showErrorToast = (message: ReactNode): string =>
  AppToast.show({ message, intent: 'danger', icon: 'error' });

export const showSuccessToast = (message: ReactNode): string =>
  AppToast.show({ message, intent: 'success', icon: 'tick-circle' });
